/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo, useEffect, useState } from "react";
import { firestore } from "../firebase/config";
import { Link } from "react-router-dom";
import {
  collection,
  doc,
  onSnapshot,
} from "firebase/firestore";
export default memo(function GetReferenceDetails(props) {
  const [refDetails, setRefDetails] = useState("No Data");
  useEffect(() => {
    let unsubSnapShot;
    async function fetchData() {
      const refId = props.refId;
      if (refId !== undefined) {
        if (!!firestore && refId !== null && refId.length > 0) {
          const donorCollection = collection(firestore, "donors");
          const docRef = doc(donorCollection, refId);
          unsubSnapShot = onSnapshot(docRef, (snapshot) => {
            if (snapshot.exists()) {
              const data = snapshot.data();

              if (data !== undefined) {
                let refFullName = data.fullName;
                props.needLink
                  ? setRefDetails(
                      <Link to={`/donordetails/${refId}`}>{refFullName}</Link>
                    )
                  : setRefDetails(refFullName);
              } else {
                setRefDetails(refId);
              }
            }
          });
        }
      } else {
        console.log(`fetchData props.refId is undefined`);
        setRefDetails("Error: refId passed is undefined");
      }
    } //end of function fetchData
    fetchData();

    return () => {
      if (unsubSnapShot) unsubSnapShot();
    };
  }, [props.refId]); //End of useEffect
  return <>{refDetails}</>;
});
